import React, { useEffect } from "react";
import { Outlet, useLocation, useNavigate } from "react-router-dom";
import FadeLoader from "react-spinners/FadeLoader";
import Header from "../../components/Header";
import { useSelector } from "react-redux";
import { useFetchUserProfileQuery } from "store/services/user.service";
import "./mainLayout.scss";

const override = {
  display: "block",
  position: "fixed",
  left: "0",
  right: "0",
  top: "50%",
  bottom: "0",
  margin: "auto",
  borderColor: "#265436",
};

const MainLayout = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const { loading } = useSelector((state) => state.loader);
  const { token } = useSelector((state) => state.auth);
  const { data: userProfile } = useFetchUserProfileQuery(undefined);
  

  return (
    <>
      <main className="MainBody position-relative">
        {loading && (
          <div className="loading-overlay position-absolute">
            <FadeLoader
              color={"#265436"}
              loading={loading}
              cssOverride={override}
              size={150}
              aria-label="Loading Spinner"
              data-testid="loader"
            />
          </div>
        )}

        {location.pathname.substring(0) === "subscription" ? (
          <>{null}</>
        ) : (
          <>
            <Header />
          </>
        )}
        <Outlet />
      </main>
    </>
  );
};

export default MainLayout;
